import React from "react";
import { ChannelListUI } from "./ChannelListUI";

export const ChannelList = (props: any) => {
  return <ChannelListUI />;
};
